const getNotificationSettings = () => 'notifications/settings';
const setNotificationSettings = () => 'notifications/employee-settings';
const getUnreadCount = () => 'notifications/counts';
const getAllNotifications = (params: { page: number; size: number }) =>
  `notifications?page=${params.page}&size=${params.size}`;
const markAllAsRead = () => 'notifications/read-all';
export const NotificationsAPI = {
  getNotificationSettings,
  setNotificationSettings,
  getUnreadCount,
  getAllNotifications,
  markAllAsRead,
};
